import { useEffect, useState } from 'react'

import { ButtonPage } from './components/ButtonPage'
import { Dashboard } from './pages/Dashboard'
import { MyTasks } from './pages/MyTasks'
import { Can } from '../../../guards/GuardContext'
import { useAuth } from '../../../contexts/AuthContext'
import { SearchTask } from '../../../components/SearchTask'
import { Medias } from '../../../enumns/medias'
import { useMediaQuery } from '../../../hooks/useMediaQuery'

enum Page {
  DASHBOARD = 'dashboard',
  MY_TASKS = 'my_tasks',
}

export const HomePage = () => {
  const { user } = useAuth()
  const [page, setPage] = useState<string>(Page.DASHBOARD)
  const isDesktopSize = useMediaQuery(`(min-width: ${Medias.LG}px)`)

  useEffect(() => {
    user?.type === 'admin' ? setPage(Page.DASHBOARD) : setPage(Page.MY_TASKS)
  }, [user])

  return (
    <div className="px-6 py-6 lg:px-16 lg:py-14">
      {!isDesktopSize && (
        <div className="mb-8">
          <SearchTask />
        </div>
      )}

      <div className="flex gap-10">
        <Can I="read" a="DashboardScreen">
          <ButtonPage
            activated={page === Page.DASHBOARD}
            onClick={() => setPage(Page.DASHBOARD)}
          >
            Dashboard
          </ButtonPage>
        </Can>
        <ButtonPage
          activated={page === Page.MY_TASKS}
          onClick={() => setPage(Page.MY_TASKS)}
        >
          Minhas Tarefas
        </ButtonPage>
      </div>

      <div>
        <Can I="read" a="DashboardScreen">
          {page === Page.DASHBOARD && <Dashboard />}
        </Can>
        {page === Page.MY_TASKS && <MyTasks />}
      </div>
    </div>
  )
}
